module.exports = __webpack_public_path__ + "img/1.222eda17.jpeg";